import Vue from 'vue'
import '@/i18n/index'

const { i18n } = Vue

export const defaultServiceValuesHeaders = [
  {
    text: i18n.translate('defaultServiceValues.label.serviceType'),
    value: 'type',
    width: '250',
  },
  {
    text: i18n.translate('defaultServiceValues.label.city'),
    value: 'city',
    width: '250',
  },
  {
    text: i18n.translate('defaultServiceValues.label.price'),
    value: 'price',
    width: '150',
    align: 'right',
  },
  {
    text: i18n.translate('defaultServiceValues.label.dateCreated'),
    value: 'date_created',
    width: '130',
    align: 'center',
  },
  {
    text: i18n.translate('defaultServiceValues.label.createdBy'),
    value: 'created_by',
    width: '250',
  },
  {
    text: i18n.translate('defaultServiceValues.label.actions'),
    value: 'actions',
    align: 'center',
    width: '80',
  },
]
